import React from 'react';
import { AlertCircleIcon, AlertTriangleIcon, InfoIcon, CheckCircleIcon } from 'lucide-react';
import { BannerState } from '../hooks/useOpportunityStatus';
interface OpportunityBannerProps {
  state: BannerState;
  onTakeAction: () => void;
}
export function OpportunityBanner({
  state,
  onTakeAction
}: OpportunityBannerProps) {
  const config = {
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-800',
      iconColor: 'text-red-500',
      Icon: AlertCircleIcon
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      text: 'text-yellow-800',
      iconColor: 'text-yellow-500',
      Icon: AlertTriangleIcon
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      iconColor: 'text-blue-500',
      Icon: InfoIcon
    },
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-800',
      iconColor: 'text-green-500',
      Icon: CheckCircleIcon
    }
  };
  const {
    bg,
    border,
    text,
    iconColor,
    Icon
  } = config[state.status];
  return <div className={`w-full border-b ${bg} ${border} px-4 py-4 sm:px-6 lg:px-8 transition-colors duration-300`} data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-start sm:items-center" data-id="element-2">
        <div className="flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-3">
          <Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" data-id="element-4" />
        </div>
        <div className="ml-3 flex-1" data-id="element-5">
          <h3 className={`text-sm font-semibold ${text}`} data-id="element-6">{state.title}</h3>
          <p className={`mt-1 text-sm ${text} opacity-90`} data-id="element-7">{state.message}</p>
        </div>
        {state.status !== 'success' && <div className="flex-shrink-0 ml-4" data-id="element-8">
            <button type="button" onClick={onTakeAction} className={`inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 ${state.status === 'error' ? 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500' : state.status === 'warning' ? 'bg-yellow-600 text-white hover:bg-yellow-700 focus:ring-yellow-500' : 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500'}`} data-id="element-9">
              Take Action
            </button>
          </div>}
      </div>
    </div>;
}